<div class="row">
  @for (option of options; track option) {
    <div class="col-sm-6">
      <label class="multi-select-checkbox">
        <input [(ngModel)]="option.checked"
          type="checkbox"
          (ngModelChange)="onOptionClick(option, $event)"/>
        <span>{{ option.label }}</span>
      </label>
    </div>
  }
</div>
